import { ADD_10_MINUTES, GLOBAL_CONFIGURATION_ENDPOINT } from "."
import { aemAxiosInstance } from "@/constants/api"

/**
 *
 * @return {{initConfig, getConfig}}
 */
function configuration() {
  let _configurationObj = {}

  const makeRequestWithRetry = async (path) => {
    let maxRetries = 3;
    let retryDelay = 1000;
    let retries = 0;

    while (true) {
      try {
        if (retries >= maxRetries - 1) {
          const tt = new Date().getTime();
          path += (path.indexOf("?") === -1 ? "?t=" : "&t=") + tt + "&" + tt
        }
        const response = await aemAxiosInstance.get(
          GLOBAL_CONFIGURATION_ENDPOINT + path
        )
        // Check if response data is an HTML string (indicating an error page)
        if (typeof response.data === 'string' && response.data.trim().startsWith('<')) {
          if (retries >= maxRetries) {
            // After max retries, return the response
            return response
          }
          retries++
          // Wait before retrying
          await new Promise(resolve => setTimeout(resolve, retryDelay))
          continue
        }
        // Valid JSON response
        return response
      } catch (error) {
        throw error
      }
    }
  }

  const initConfig = async () => {
    let urlPath = window.location.pathname
    urlPath =  urlPath === '/' ? "/en" : urlPath
    _configurationObj = localStorage?.getItem(`caConfig${document.documentElement?.lang ? ("-" + document.documentElement?.lang) : ""}`)
      ? JSON.parse(
          localStorage.getItem(`caConfig${document.documentElement?.lang ? ("-" + document.documentElement?.lang) : ""}`)
      )
      : {
        expireTime: 0,
      }
    const currentTime = new Date()?.getTime()
    if (currentTime > _configurationObj.expireTime || !_configurationObj.plpServletPath?.length) {
       await makeRequestWithRetry(`?path=${urlPath}&caConfig=true`).then(response => {
        if (response && response.data) {
          const _backendConfig = response.data

          if (_backendConfig?.general?.isPublish) {
            const getShortenedUrl = uUrl => {
              const shortUrl = _backendConfig?.general?.shortendPagePath ?? ""
              const shortUrlRegEx = new RegExp(shortUrl, "g")
              const htmlRegExp = new RegExp(".html", "g")
              return uUrl.replace(shortUrlRegEx, "").replace(htmlRegExp, "")
            }

            const pattern = `^(?!.*json)${_backendConfig.general.shortendPagePath}.*`

            for (const link in _backendConfig.general) {
              if ({}.hasOwnProperty.call(_backendConfig.general, link)) {
                const url = `${_backendConfig.general[link]}`
                if (url.match(pattern)) {
                  if (link !== "shortendPagePath")
                    _backendConfig.general[link] = getShortenedUrl(
                      _backendConfig.general[link]
                    )
                }
              }
            }
          }
          _configurationObj = Object.assign(_configurationObj, _backendConfig)

          const MapObjects = new Set([
            "regexPattern",
            "annsacksPDPConfig",
            "salesChannelConfig",
            "apiEndPointData",
            "legalPageData",
            "contentFragmentListConfig"
          ]);
          Object.keys(_configurationObj).forEach((configKey) => {
            if (MapObjects.has(configKey) && _configurationObj[configKey].map) {
              _configurationObj[configKey] = _configurationObj[configKey].map;
            }
          })
          if (_configurationObj.socialMediaConfig?.myArrayList?.find((item) => item?.map)) {
            _configurationObj.socialMediaConfig.myArrayList = _configurationObj.socialMediaConfig.myArrayList.map((item) => item.map);
          }
          const assetAccountName =
            response.data?.general.scene7AccountName ?? "PAWEB"
          _configurationObj.general.swatchUrl =
            _configurationObj.general.swatchUrl.replace(
              "PAWEB",
              assetAccountName
            )

          // Make the second API call after getting the plpServletPath parameter
          return makeRequestWithRetry(_configurationObj.general?.plpServletPath ? "?path=" + _configurationObj.general.plpServletPath : "")
        } else {
          console.error("Error occurred while fetching Backend Configuration")
        }
      })
      .then(res => {
          if (res && typeof res?.data !== "string") {
            _configurationObj.plpServletPath = res.data.pdpURLMapping || [];
            _configurationObj.expireTime = new Date().getTime() + ADD_10_MINUTES
            if (localStorage) {
              localStorage.setItem(
                `caConfig-${document.documentElement.lang}`,
                JSON.stringify(_configurationObj)
              )
            }
          }
        })
        .catch(err =>
          console.error("Error occurred while fetching PLP Servlet path", err)
        )
    } else {
      console.log("Configuration URL for found")
    }
  }

  const getConfig = async () => {
    let configTimer
    const config = new Promise(resolve => {
      if (_configurationObj?.expireTime === 0) {
        configTimer = setTimeout(() => resolve(getConfig()), 500)
      } else {
        configTimer && clearTimeout(configTimer)
        resolve(_configurationObj)
      }
    })
    return config
  }
  return {
    initConfig,
    getConfig,
  }
}

export const { initConfig, getConfig } = configuration()
